import { Box, Skeleton } from '@mui/material';

/** Number of placeholder rows in the skeleton to mimic transcription entries. */
const SKELETON_ROW_COUNT = 3;

/** Width ratio for speaker column (narrow) vs text column (wide), matching the table layout. */
const TIME_COLUMN_WIDTH = '40px';

/**
 * Skeleton loader that mirrors the transcription table UI: card with header (Speaker Label | Texto)
 * and content rows with narrow speaker cell and variable-length text cell.
 */
export function TranscriptionSkeleton({ rowCount = SKELETON_ROW_COUNT }: { rowCount?: number }) {
  return (
    <Box sx={{ marginTop: '1rem' }}>
      <Box
        sx={{
          position: 'relative',
          borderRadius: 2,
          boxShadow: 1,
          bgcolor: 'background.paper',
          overflow: 'hidden',
        }}
      >
        {Array.from({ length: rowCount }).map((_, i) => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 2,
              borderBottom: 1,
              borderColor: 'divider',
              px: 2,
              py: 1.5,
              '&:last-of-type': { borderBottom: 0 },
            }}
          >
            <Skeleton
              variant="text"
              width={72}
              height={20}
              sx={{ flexShrink: 0, flex: `0 0 ${TIME_COLUMN_WIDTH}` }}
            />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Skeleton
                variant="text"
                width={'20%'}
                height={12}
                sx={{ display: 'block', mb: 0.5 }}
              />
              <Skeleton
                variant="text"
                width={i % 3 === 0 ? '100%' : i % 3 === 1 ? '75%' : '55%'}
                height={20}
                sx={{ display: 'block' }}
              />
              {i % 2 === 0 && (
                <Skeleton
                  variant="text"
                  width="90%"
                  height={20}
                  sx={{ display: 'block', mt: 0.5 }}
                />
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
